// extracted by mini-css-extract-plugin
export default {"gallery-section":"Gallery_gallery-section__bOyED","header":"Gallery_header__IdOlX","gallery-heading-text":"Gallery_gallery-heading-text__fkaQP"};